import React, { useState } from 'react';
import BlogModal from './BlogModal';
import '../../assets/styles/blogCardsSection.scss';

export type BlogCard = {
  id: string | number;
  image: string;
  date: string;
  title: string;
  slug: string;
  content: string;
  videoUrl?: string;
};

export type BlogCardsSectionProps = {
  title: string;
  cards: BlogCard[];
  titleColor?: string;
  buttonColor?: string;
  accentColor?: string;
};

const BlogCardsSection: React.FC<BlogCardsSectionProps> = ({
  title,
  cards,
  titleColor = '#2cadd2',
  buttonColor = '#2cadd2',
  accentColor = '#2cadd2',
}) => {
  const [selectedCard, setSelectedCard] = useState<BlogCard | null>(null);

  const styleVars = {
    '--bcs-title-color': titleColor,
    '--bcs-button-color': buttonColor,
    '--bcs-accent-color': accentColor,
  } as React.CSSProperties;

  return (
    <section className="blog-cards-section" style={styleVars}>
      <div className="bcs-container">
        <h2 className="bcs-title">{title}</h2>
        
        <div className="bcs-grid">
          {cards.map((card) => (
            <article key={card.id} className="bcs-card">
              <div className="bcs-image">
                <img src={card.image} alt={card.title} loading="lazy" />
              </div>
              <div className="bcs-content">
                <time className="bcs-date">{card.date}</time>
                <h3 className="bcs-card-title">{card.title}</h3>
                <button 
                  onClick={() => setSelectedCard(card)} 
                  className="bcs-button"
                >
                  Devamını Oku
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <div className="bcs-accent-line"></div>
              </div>
            </article>
          ))}
        </div>
      </div>

      {selectedCard && (
        <BlogModal
          isOpen={!!selectedCard}
          onClose={() => setSelectedCard(null)}
          title={selectedCard.title}
          date={selectedCard.date}
          image={selectedCard.image}
          content={selectedCard.content}
          videoUrl={selectedCard.videoUrl}
        />
      )}
    </section>
  );
};

export default BlogCardsSection;
